import { create } from "zustand";
import { persist } from "zustand/middleware";

interface PanelState {
  leftPanelVisible: boolean;
  rightPanelVisible: boolean;
  propertiesTabRequested: boolean;
  setLeftPanelVisible: (visible: boolean) => void;
  setRightPanelVisible: (visible: boolean) => void;
  toggleLeftPanel: () => void;
  toggleRightPanel: () => void;
  requestPropertiesTab: () => void;
  clearPropertiesTabRequest: () => void;
}

export const usePanelState = create<PanelState>()(
  persist(
    (set) => ({
      leftPanelVisible: true,
      rightPanelVisible: true,
      propertiesTabRequested: false,
      setLeftPanelVisible: (leftPanelVisible) => set({ leftPanelVisible }),
      setRightPanelVisible: (rightPanelVisible) => set({ rightPanelVisible }),
      toggleLeftPanel: () =>
        set((state) => ({ leftPanelVisible: !state.leftPanelVisible })),
      toggleRightPanel: () =>
        set((state) => ({ rightPanelVisible: !state.rightPanelVisible })),
      requestPropertiesTab: () =>
        set({ rightPanelVisible: true, propertiesTabRequested: true }),
      clearPropertiesTabRequest: () => set({ propertiesTabRequested: false }),
    }),
    {
      name: "ramp-editor-v2-panels",
    }
  )
);
